
import React from 'react';
import { motion } from 'framer-motion';
import { Star, MessageCircle, ThumbsUp } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: "Juan Engelbrecht",
      text: "legend sir. thanks i think we got our first 100k via your network 🙂",
      location: "US",
      img: "/lovable-uploads/258bf107-cbf5-49d0-9290-a3eeb283042d.png"
    },
    {
      id: 2,
      name: "William Rhymer",
      text: "I've been using Cisero for about a month at a very slow rate because of the other things I'm busy with in my business. Even with that I was able to generate $30k in profit. Looking forward to this next month of having it fully ramped up.",
      location: "CO",
      img: "/lovable-uploads/12a9aa49-d1a6-4ff5-b73a-6d208b9c08d2.png"
    },
    {
      id: 3,
      name: "Blake Moser",
      text: "Cisero AI offers the full suite needed for cold email marketing. If you are seeking contacts and a method to send large volumes of emails, Cisero provides guidance of the tools needed to get the job done. Excellent training. Access to targeted contacts. Insights on the systems needed to scale.",
      location: "US",
      img: "/lovable-uploads/05bf42f4-300b-472b-a46c-7fe756de14b8.png"
    },
    {
      id: 4,
      name: "Geoff Phelan",
      text: "FINALLY, I found an inbound appointment system that works that is scalable! Working with Tristen and CISERO's team has been game-changing for me and my tech consulting agency. Couldn't be happier with the impact it's had on my life and business.",
      location: "US",
      img: "/lovable-uploads/43743775-7033-4d4c-b193-ebf324b5c09b.png"
    },
    {
      id: 5,
      name: "Saifullah jubayer",
      text: "I was skeptical because of reviews I read about the founder but were glad we chose Cisero. Our team was looking for an AI tool that could give us appointments organically without needing to keep paying for ads. The first 2 weeks was all set up and then we launched with 6-10 leads a day coming in now which were very happy with. Now I'm working with Smit to help us get close to 20 meetings a day. Hoping for the best! 5 stars from me.",
      location: "BD",
      img: "/lovable-uploads/cfe8e25e-228e-4531-b634-f410e184a390.png"
    },
    {
      id: 6,
      name: "Sandler Lewolt",
      text: "We found the system to be very valuable in reaching our audience very efficiently. Our home services team ended up 20% greater in sales than anticipated and we think this played a big part.",
      location: "CO",
      img: "/lovable-uploads/9a9def6e-2396-4fb2-ba0a-36a60e91931a.png"
    },
    {
      id: 7, 
      name: "Frank",
      text: "The whole experience at Cisero.ai from onboarding to the Team thru the whole process was great. But the results are amazing. I have more qualified appointments than I can handle - I have had to add sales people. Great communication from the support team!",
      location: "US",
      img: "/lovable-uploads/18b8a76c-9007-4fbf-b3e0-cc92b07d922e.png" 
    },
    {
      id: 8,
      name: "Max Brown",
      text: "Cisero AI has been a game-changer for our sales team. The data-driven insights and personalized playbooks have helped us close deals faster and with more confidence. The real-time coaching feature is a lifesaver, providing on-the-spot guidance that improves our reps' negotiation skills and objection handling. We've seen a significant increase in win rates since implementing Cisero AI, and our team morale is higher than ever. Highly recommend!!!",
      location: "NG",
      img: "/lovable-uploads/368d3cd0-d87b-4873-a63a-e33d8613d55f.png"
    },
    {
      id: 9,
      name: "Neil Kravets",
      text: "I recently explored CISERO and was highly impressed by its innovative approach to sales meetings. The platform leverages advanced AI to fully automate marketing efforts, allowing businesses to reach millions of prospects without the escalating costs typical of traditional advertising methods. CISERO stands out by providing precise targeting and continuous optimization of messaging, ensuring high conversion rates. This tool is a game-changer for scaling sales operations efficiently, saving significant time and resources while maximizing outreach and impact. Highly recommended for businesses looking to revolutionize their sales strategy.",
      location: "US",
      img: "/lovable-uploads/1d6bb651-1f9c-4028-ac81-e134a767c816.png"
    },
    {
      id: 10,
      name: "Ousama Elkacimi",
      text: "I've been using Cisero AI and it's been fantastic for generating Appointments. The platform has significantly boosted our inbound sales appointments, reaching up many thousands prospects daily. It's cost-effective and user-friendly, with excellent customer support providing valuable strategies. Overall, Cisero AI is a reliable and efficient tool and game changer for any business looking to enhance their sales process. Highly recommended!",
      location: "MA",
      img: "/lovable-uploads/979f1a71-5fa4-4154-bc5e-34a57f50802b.png"
    },
    {
      id: 11,
      name: "Derby Walker",
      text: "We booked an average of 6 appointments a day which we are pretty happy with.",
      location: "US",
      img: "/lovable-uploads/39a9cb74-c365-4509-897f-c93b02f6e36e.png"
    }
  ];

  return (
    <div className="bg-gray-50 rounded-lg p-8 mb-12 shadow-xl">
      <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Results They Paid $25,000 For:</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {testimonials.map((testimonial) => (
          <motion.div
            key={testimonial.id}
            className="bg-white p-6 rounded-lg shadow-md"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: testimonial.id * 0.1 }}
          >
            <div className="flex items-center mb-4">
              <img 
                src={testimonial.img} 
                alt={`${testimonial.name}'s avatar`} 
                className="w-12 h-12 rounded-full mr-4 object-cover"
              />
              <div>
                <p className="font-bold text-gray-900">{testimonial.name}</p>
                <div className="flex items-center">
                  <span className="text-sm text-gray-500 mr-2">{testimonial.location}</span>
                  <div className="flex">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star key={star} className="h-4 w-4 text-green-500 fill-green-500" />
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <p className="text-gray-700 mb-3">{testimonial.text}</p>
            <div className="flex justify-end items-center text-gray-500 text-sm">
              <ThumbsUp className="h-4 w-4 mr-1" />
              <span className="mr-3">Helpful</span>
              <MessageCircle className="h-4 w-4 mr-1" />
              <span>Comment</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialsSection;
